/**
 * Theme Reducer
 * Manages organization branding/theme state
 */

import * as actionTypes from '../actions';

const initialState = {
  // Loading state
  loading: false,
  initialized: false,

  // Current branding data
  branding: null,
  domain: null,

  // Cache status
  cacheHit: false,

  // Error state
  error: null,

  // Metadata
  lastUpdated: null
};

/**
 * Theme reducer
 */
const themeReducer = (state = initialState, action) => {
  switch (action.type) {
  case actionTypes.THEME_LOAD_REQUEST: {
    return {
      ...state,
      loading: true,
      error: null,
      domain: action.payload?.domain || state.domain
    };
  }

  case actionTypes.THEME_LOAD_SUCCESS: {
    return {
      ...state,
      loading: false,
      initialized: true,
      branding: action.payload.branding,
      domain: action.payload.domain,
      cacheHit: action.payload.cacheHit || false,
      error: null,
      lastUpdated: new Date().toISOString()
    };
  }

  case actionTypes.THEME_LOAD_FAILURE: {
    return {
      ...state,
      loading: false,
      error: action.payload.error,
      branding: action.payload.fallbackBranding || state.branding
    };
  }

  case actionTypes.THEME_RESET: {
    return {
      ...initialState,
      initialized: state.initialized
    };
  }

  case actionTypes.THEME_INVALIDATE_CACHE: {
    return {
      ...state,
      cacheHit: false
    };
  }

  default:
    return state;
  }
};

export default themeReducer;
